import { Quote, Camera } from "lucide-react";
import { TIMELINE, CHALLENGES, FOUNDER, FOUNDER_PHOTOS } from "../data/content";
import { Reveal, Overline } from "./Reveal";

export const Founder = () => (
  <section id="founder" data-testid="founder-section" className="border-y border-navy/10 bg-slate-50 py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <Overline>The founder</Overline>
              <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-navy sm:text-5xl">
                {FOUNDER.name}
              </h2>
              <p className="mt-2 font-mono text-xs uppercase tracking-[0.15em] text-slate-500">{FOUNDER.role}</p>

              <blockquote className="mt-8 border-l-4 border-electric bg-white p-6 hard-shadow-sm" data-testid="founder-quote">
                <Quote size={20} className="text-electric" />
                <p className="mt-3 font-display text-xl font-bold leading-snug text-navy">
                  “{FOUNDER.quote}”
                </p>
              </blockquote>

              <div className="mt-8 flex flex-wrap gap-2" data-testid="founder-certs">
                {FOUNDER.certs.map((c) => (
                  <span key={c} className="border border-navy/25 bg-white px-3 py-1.5 font-mono text-[10px] font-semibold uppercase tracking-[0.12em] text-navy">
                    {c}
                  </span>
                ))}
              </div>

              <div className="mt-8 grid grid-cols-3 gap-3" data-testid="founder-photos">
                {FOUNDER_PHOTOS.map((p) => (
                  <div
                    key={p.id}
                    data-testid={p.id}
                    className="flex aspect-[3/4] items-center justify-center border border-dashed border-navy/30 bg-white"
                  >
                    {p.src ? (
                      <img src={p.src} alt={p.alt} className="h-full w-full object-cover" />
                    ) : (
                      <span className="flex flex-col items-center gap-2 text-navy/40">
                        <Camera size={18} />
                        <span className="px-2 text-center font-mono text-[9px] uppercase tracking-[0.12em]">
                          Photo coming soon
                        </span>
                      </span>
                    )}
                  </div>
                ))}
              </div>

              <p className="mt-8 max-w-md text-sm leading-relaxed text-slate-600">
                Trained in the United States, tested on American job sites, and back home in Patna
                to build — a first-generation businessman who started {`Subhankara`} in October 2020
                with no legacy network and no shortcuts.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="relative border-l-2 border-navy/15 pl-8">
            {TIMELINE.map((t, i) => (
              <Reveal key={t.year + t.title} delay={i * 0.05}>
                <div
                  data-testid={`timeline-${i}`}
                  className={`relative mb-8 border bg-white p-6 transition-colors ${
                    t.highlight ? "border-electric hard-shadow-blue" : "border-slate-200"
                  }`}
                >
                  <span
                    className={`absolute -left-[41px] top-7 h-4 w-4 rotate-45 border-2 ${
                      t.highlight ? "border-electric bg-electric" : "border-navy bg-white"
                    }`}
                  />
                  <p className={`font-mono text-xs font-bold tracking-[0.15em] ${t.highlight ? "text-electric" : "text-slate-500"}`}>
                    {t.year}
                  </p>
                  <h3 className="mt-2 font-display text-lg font-bold tracking-tight text-navy">{t.title}</h3>
                  <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.08em] text-slate-500">{t.org}</p>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600">{t.note}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-20">
        <Reveal>
          <Overline>Chapter — the first generation</Overline>
          <h3 className="mt-4 max-w-2xl font-display text-2xl font-extrabold tracking-tight text-navy sm:text-4xl">
            What it takes to start with nothing but a degree and a drawing board.
          </h3>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {CHALLENGES.map((c, i) => (
            <Reveal key={c.index} delay={i * 0.08}>
              <div
                data-testid={`challenge-${c.index}`}
                className="h-full border border-slate-200 bg-white p-6 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-electric"
              >
                <p className="font-mono text-2xl font-bold text-electric">{c.index}</p>
                <h4 className="mt-4 font-display text-base font-bold text-navy">{c.title}</h4>
                <p className="mt-2 text-xs leading-relaxed text-slate-600">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
